namespace Matrix {
    export interface TableExcelExportColumn {
        Name?: string;
        Title?: string;
        Width?: number;
        Format?: string;
        WrapText?: boolean;
    }
}
